export default __webpack_public_path__ + "static/media/Filtro.a7fa1c2b.jpg";